import { Environments, getEnvironmentFromHost } from '../api/endpoints';

const ClubCodeURLMap: { [club: string]: string } = {
  '004': 'calif',
  '252': 'texas',
  '601': 'newmexico',
  '018': 'hawaii',
  '036': 'northernnewengland',
  '001': 'alabama',
  '215': 'eastcentral',
  '258': 'tidewater',
  '065': 'autoclubmo',
};

export class URLHelper {
  static getMyAccountURL(clubCode: string) {
    const clubName = ClubCodeURLMap[clubCode] || 'calif';
    return `https://apps2.${clubName}.aaa.com/aceapps/myaccount`;
  }
}

export const loginOnClick = (clubCode: string) => {
  const myaccountURL = URLHelper.getMyAccountURL(clubCode);
  window.open(myaccountURL);
};

export const createAccountOnClick = () => {
  const env = getEnvironmentFromHost(window.location.hostname);
  env === Environments.prod
    ? window.open(`https://app.ace.aaa.com/enterprise/identity/#/register`)
    : window.open(`https://${window.location.hostname}/enterprise/identity/${env}/#/register`);
};

export const getTermsUrl = () => {
  const env = getEnvironmentFromHost(window.location.hostname);
  let termsUrl = '';

  switch (env) {
    case Environments.dev:
      termsUrl = 'https://appdev1.ace.aaa.com/payments/termsandconditions';
      break;
    case Environments.qa:
      termsUrl = 'https://appqa1.ace.aaa.com/payments/termsandconditions';
      break;
    case Environments.uat:
      termsUrl = 'https://appuat1.ace.aaa.com/payments/termsandconditions';
      break;
    default:
      termsUrl = 'https://app.ace.aaa.com/payments/termsandconditions';
      break;
  }
  return termsUrl;
};
